// libs
import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

// component
import Input from '../../../../forms/fields/input/Input';

function SearchInput() {
  return (
    <div className="filter__input">
      <Field
        name="keywords"
        component={Input}
        type="text"
        label="keywords"
      />
    </div>
  );
}

SearchInput.contextTypes = {
  t: PropTypes.func,
};

SearchInput.propTypes = {
};

export default SearchInput;



// WEBPACK FOOTER //
// ./src/app/components/pages/search/form/parts/SearchInput.js